import companySettingsService from '@/api/CompanySettings';
import {defineStore} from 'pinia'


export interface CompanySettings {
    logo: string;
    logoFile: File | null;
    name: string;
    address: string;
    city: string;
    country: string;
    zip: string;
    email: string;
    contactPerson: string;
    phoneNumber: string;
    taxNumber: string;
    swift: string;
    iban: string;
    bank: string;
    version: number;
    colorCode: string;
    sidebarColorCode: string;
    sidebarIconColorCode: string;
    sidebarLinkColorCode: string;
    calendarEnabled: boolean;
    timeManagementEnabled: boolean;
    holidayEnabled: boolean;
    coursePrivateCoachingEnabled: boolean;
    courseGroupCoachingEnabled: boolean;
    coursePrivateLearningCoachingEnabled: boolean;
    courseAssistedLivingCoachingPriceEnabled: boolean;
    courseSocioTherapyCoachingPriceEnabled: boolean;
    locationEnabled: boolean;
    locationAuditEnabled: boolean;
    federalStateEnabled: boolean;
    meetingRoomEnabled: boolean;
    clientEnabled: boolean;
    subClientEnabled: boolean;
    userEnabled: boolean;
    addressBookEnabled: boolean;
    unemployedEnabled: boolean;
    privateCoachingEnabled: boolean;
    groupCoachingEnabled: boolean;
    socioTherapyCoachingEnabled: boolean;
    assistedLivingCoachingEnabled: boolean;
    privateLearningCoachingEnabled: boolean;
    caseManagementCoachingEnabled: boolean;
    addressBookCompanyEnabled: boolean;
    addressBookClientEnabled: boolean;
    addressBookDoctorEnabled: boolean;
    addressBookPrivateCustomerEnabled: boolean;
    addressBookPartnerPracticesEnabled: boolean;
    billingEnabled: boolean;
    coachBillingEnabled: boolean;
    emailEnabled: boolean;
    cronExecutionEnabled: boolean;
    aiDocumentScanEnabled: boolean;
    deletedRecordsEnabled: boolean;
    travelExpensesEnabled: boolean;
    analyticsEnabled: boolean;
    assistedLivingCoachingUnitsInWeek: number | null;
    logoUrl: string;
    companyKey: string
}

export const piniaCompanySettingsStore = defineStore('companySettings', {
    state: (): { companySettings: CompanySettings | null } => ({
        companySettings: null,
    }),

    actions: {
        async getCompanySettings() {
            try {
                const { data } = await companySettingsService.getSettings();
                this.companySettings = data.data;
            } catch (err) {
                console.error(err);
            }
        },
    }
});
